// 导入组件，组件必须声明 name
import videoPreview from "./src/videoPreview.vue";

videoPreview.install = function(Vue) {
  Vue.component(videoPreview.name, videoPreview);
};

export default videoPreview;
